import React, { ReactElement } from "react";

import { Layout } from "../../generated/gql/graphql";

import CanvasPanelContent, {
  CanvasPanelContentProps,
} from "./canvas-panel-content";
import CanvasPanelHeader, {
  CanvasPanelHeaderProps,
} from "./canvas-panel-header";

export type CanvasPanelProps = Pick<
  CanvasPanelHeaderProps,
  "selectedCanvasObject" | "selectedCanvasObjectChange"
> &
  Pick<
    CanvasPanelContentProps,
    | "layout"
    | "backgroundId"
    | "scale"
    | "scaleChange"
    | "scaleChangeEnd"
    | "offset"
    | "offsetChange"
    | "scaleOffsetChange"
    | "selectedCanvasObject"
    | "selectedCanvasObjectIndex"
    | "canvasObjects"
    | "objectChanged"
    | "objectDuplicated"
    | "objectDeleted"
    | "objectMoved"
    | "objectSelected"
    | "handleProductInputsChange"
    | "aspectRatio"
    | "aspectRatioChange"
    | "finalAspectRatio"
    | "canvasSize"
  > & {
    layout: Pick<Layout, "name">;
  };

export default function CanvasPanel({
  layout,
  backgroundId,
  selectedCanvasObject,
  selectedCanvasObjectChange,
  canvasObjects,
  ...canvasPanelContentProps
}: CanvasPanelProps): ReactElement {
  return (
    <section className="shadow-xl flex h-full w-full max-w-screen-lg flex-col rounded-xl bg-white">
      <CanvasPanelHeader
        title={layout.name ?? "Editor"}
        selectedCanvasObject={selectedCanvasObject}
        selectedCanvasObjectChange={selectedCanvasObjectChange}
        backgroundId={backgroundId}
        canvasObjects={canvasObjects}
        canvasSize={canvasPanelContentProps.canvasSize}
      />
      <CanvasPanelContent
        layout={layout}
        backgroundId={backgroundId}
        selectedCanvasObject={selectedCanvasObject}
        canvasObjects={canvasObjects}
        {...canvasPanelContentProps}
      />
    </section>
  );
}
